var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['franchise-notifications-box', _vm.addClass]},[_c('div',{staticClass:"franchise-notifications-box__content"},[_c('status-dot'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.text))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }